<div class="app-layout min-h-screen border-red bg-[var(--bg-dark)] text-[var(--text-main)] flex">
  <app-toast></app-toast>
  <!-- Sidebar -->
  @if (!isLoginRoute) {
    <app-sidebar class="border-r border-[var(--border-color)] bg-[var(--bg-panel)] h-screen flex-shrink-0 sticky top-0 z-20"></app-sidebar>
  }
  
  <!-- Main Content Sequence -->
  <div class="flex-1 flex flex-col min-w-0">
    <!-- Header -->
    @if (!isLoginRoute) {
      <app-header class="h-16 border-b border-[var(--border-color)] bg-[var(--bg-panel)]/80 backdrop-blur-md flex-shrink-0 sticky top-0 z-10"></app-header>
    }
    
    <!-- Page Content -->
    <main class="flex-1 overflow-y-auto" [class]="!isLoginRoute ? 'p-4 sm:p-6 lg:p-8' : ''">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

@if (devProdSyncModal.isOpen()) {
  <app-dev-prod-sync-modal (closeModal)="devProdSyncModal.close()"></app-dev-prod-sync-modal>
}
